import React from 'react';
import { Oval } from 'react-loader-spinner';
import './LoadingSpinner.scss';

/**
 * Consistent loading spinner component using the design system colors
 *
 * @param {string} size - 'small' (20px), 'medium' (40px), 'large' (80px - default)
 * @param {string} variant - 'primary' (slate gray), 'light' (white for dark backgrounds)
 * @param {boolean} fullPage - Whether to center in full viewport height
 * @param {string} className - Additional CSS classes
 */
const LoadingSpinner = ({
  size = 'large',
  variant = 'primary',
  fullPage = true,
  className = '',
}) => {
  const sizeMap = {
    small: 20,
    medium: 40,
    large: 80,
  };

  // Using CSS variables from design system
  const colorMap = {
    primary: {
      color: '#2c5f8d', // --color-primary-500 (Medical Blue)
      secondaryColor: '#2c5f8d',
    },
    light: {
      color: '#ffffff',
      secondaryColor: 'rgba(255, 255, 255, 0.5)',
    },
  };

  const dimensions = sizeMap[size] || sizeMap.large;
  const colors = colorMap[variant] || colorMap.primary;

  return (
    <div className={`loading-spinner ${fullPage ? 'loading-spinner--full-page' : ''} ${className}`}>
      <Oval
        height={dimensions}
        width={dimensions}
        color={colors.color}
        secondaryColor={colors.secondaryColor}
        strokeWidth={2}
        strokeWidthSecondary={2}
        visible={true}
        ariaLabel="loading"
      />
    </div>
  );
};

export default LoadingSpinner;
